import { Stack } from '@chakra-ui/react'
import { useContext, useEffect, useRef } from 'react'
import { connectHits } from 'react-instantsearch-dom'
import useIntersection from 'src/hooks/useIntersection'
import Snippet from './Snippet'
import { searchConfigContext } from './SearchableFeedProvider'
import Card from 'src/common/Card'

/**
 * searchable feed hits
 */
function HitsComponent({
  hits,
  containerProps = { maxW: 'container.md', mx: 'auto' },
  truncateTextWidth = '540px',
}) {
  const firstRender = useRef(true)
  const { register, entry } = useIntersection()
  const { paginate } = useContext(searchConfigContext)

  useEffect(() => {
    if (!firstRender.current && entry.isIntersecting) paginate(hits.length)
    firstRender.current = false
  }, [entry])

  return (
    <Stack
      // doing this instead of ...rest because algolia passes
      // a bunch of stuff to this component
      {...containerProps}
    >
      {(hits.length === 0) && (
        <Card p={['base', 'base', 'base']}>
          No results. Try changing the topics.
        </Card >
      )}
      {hits.map((hit, i) => (
        <Snippet
          key={hit.objectID}
          hit={hit}
          truncateTextWidth={truncateTextWidth}
          register={(i === hits.length - 1) ? register : (e) => { }}
          mb={6}
        />
      ))}
    </Stack>
  )
}

const Hits = connectHits(HitsComponent)

export default Hits
